import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { ModalController, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-pro-approve-case',
  templateUrl: './pro-approve-case.component.html'
})
export class ProApproveCaseComponent implements OnInit {
  approveForm: FormGroup = new FormGroup({});
  pan: string;
  applicantName: string;

  constructor(private modalCtrl: ModalController, private toastController: ToastController) { }

  ngOnInit(): void { 
    this.approveForm = new FormGroup({
      outwardNo: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(100)])
    });  
  }

  approve() {
    if (this.approveForm.valid) {
      return this.modalCtrl.dismiss(this.approveForm.value.outwardNo, 'approve');
    }
    else {
      
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

}
